/* eslint-disable max-len */

const ChevronLeft: React.FC = () => (
<svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2.47606 5.64683L2.12328 6.00039L2.47645 6.35355L6.70414 10.5812L5.99875 11.2916L0.707107 6L6 0.707107L6.70328 1.41039L2.47606 5.64683Z"/>
</svg>
);

export default ChevronLeft;
